import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "./index.css";
import { AuthProvider } from "./context/AuthContext";
import { ProtectedRoute } from "./app/ProtectedRoute";
import { LandingPage } from "./landing/LandingPage";
import { AppShell } from "./app/AppShell";
import { Dashboard } from "./app/Dashboard";
import { Clients } from "./app/Clients";
import { Rentals } from "./app/Rentals";
import { Payments } from "./app/Payments";
import { Fleet } from "./app/Fleet";
import { Maintenance } from "./app/Maintenance";
import { Shop } from "./app/Shop";
import { Settings } from "./app/Settings";
import { Login } from "./app/Login";

const qc = new QueryClient({ defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false } } });

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={qc}>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/app/login" element={<Login />} />
            <Route path="/app" element={<ProtectedRoute><AppShell /></ProtectedRoute>}>
              <Route index element={<Dashboard />} />
              <Route path="clients" element={<Clients />} />
              <Route path="rentals" element={<Rentals />} />
              <Route path="payments" element={<Payments />} />
              <Route path="vehicles" element={<Fleet />} />
              <Route path="maintenance" element={<Maintenance />} />
              <Route path="shop" element={<Shop />} />
              <Route path="settings" element={<Settings />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
